import React from 'react';

export const DayPopoverContext = React.createContext(true);

export function useDayPopover() {
  return React.useContext(DayPopoverContext);
}
